<template>
  <div class="critical-document-wrapper">
    <div class="page-sheet">
      <!-- Encabezado Oficial -->
      <table class="header-table">
        <tbody>
          <tr>
            <td class="header-logo-cell">
              <img src="/static/logo_sp.png" alt="Sunshine" class="company-logo" />
            </td>
            <td class="header-title-cell">
              <div class="main-title">CROQUIS DE DOMICILIO</div>
            </td>
            <td class="header-meta-cell">
              <div><strong>CÓDIGO :</strong> SIG-CS-RH-FR-048</div>
              <div><strong>VERSIÓN :</strong> 01</div>
              <div><strong>Fecha de Creación :</strong> 20/01/2023</div>
              <div><strong>Ultima Revisión :</strong> 15/07/2025</div>
              <div><strong>Páginas :</strong> 1 de 1</div>
              <div><strong>Anexos :</strong> 00</div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Datos del Trabajador -->
      <div class="worker-meta-section mt-4 font-size-12">
        <div class="meta-row">
          <span class="meta-label">Apellidos y Nombres:</span>
          <span class="meta-value">{{ workerData.NtpFullName || '' }}</span>
        </div>
        <div class="meta-row mt-2">
          <span class="meta-label">Dirección:</span>
          <span class="meta-value">{{ workerData.Address || '' }}</span>
        </div>
        <div class="meta-row mt-2">
          <span class="meta-label">Fecha:</span>
          <span class="meta-value">{{ formattedDate }}</span>
        </div>
      </div>

      <!-- Texto Explicativo -->
      <div class="sketch-explanation mt-4 font-size-12 text-justify line-height-14">
        Mediante el presente se indica el croquis de mi domicilio actual de residencia, en el que se muestra las principales vías de acceso y puntos de referencia.
      </div>

      <!-- Recuadro para Dibujo o Croquis -->
      <div class="sketch-drawing-box mt-3">
        <div class="sketch-inner-hint">Área para croquis, mapa o indicaciones de llegada</div>
      </div>

      <!-- Sección de Firmas -->
      <table class="sketch-signature-table mt-4">
        <tbody>
          <tr>
            <td class="worker-signature-cell">
              <div class="worker-boxes-wrapper">
                <div class="signature-box-inner"></div>
                <div class="fingerprint-box-inner"></div>
              </div>
              <div class="cell-label">Firma y Huella del Trabajador</div>
            </td>
            <td class="admin-signature-cell">
              <div class="admin-box-inner"></div>
              <div class="cell-label">V°B° Area Administ. de Personal</div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Pie BASC Oficial -->
      <div class="page-footer-note">
        Se prohíbe la reproducción total o parcial de este documento sin autorización del Representante BASC
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CriticalAddressSketch",
  props: {
    workerData: {
      type: Object,
      default: () => ({}),
    },
    documentDate: {
      type: String,
      default: null,
    },
  },
  computed: {
    formattedDate() {
      const raw = this.documentDate || this.workerData.AgtBeginDate;
      if (raw) {
        const parts = String(raw).substring(0, 10).split("-");
        if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
      }
      const now = new Date();
      const dd = String(now.getDate()).padStart(2, "0");
      const mm = String(now.getMonth() + 1).padStart(2, "0");
      const yyyy = now.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    },
  },
};
</script>

<style scoped>
.critical-document-wrapper {
  font-family: Arial, sans-serif;
  color: #000;
  background: transparent;
}

.page-sheet {
  background: #ffffff;
  width: 100%;
  max-width: 760px;
  min-height: 1060px;
  margin: 0 auto 30px auto;
  padding: 30px 40px;
  border: 1px solid #dcdcdc;
  box-sizing: border-box;
  position: relative;
}

.header-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
}

.header-table td {
  border: 1px solid #000;
  vertical-align: middle;
  padding: 8px 6px;
}

.header-logo-cell {
  width: 25%;
  text-align: center;
}

.company-logo {
  max-width: 125px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.header-title-cell {
  width: 45%;
  text-align: center;
}

.main-title {
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.header-meta-cell {
  width: 30%;
  font-size: 9px;
  line-height: 1.35;
  padding-left: 8px !important;
}

.worker-meta-section {
  font-size: 12px;
}

.meta-row {
  display: flex;
  align-items: baseline;
}

.meta-label {
  font-weight: bold;
  margin-right: 8px;
  white-space: nowrap;
}

.meta-value {
  flex: 1;
  border-bottom: 1px dotted #555;
  padding: 0 4px;
  min-height: 18px;
}

.sketch-explanation {
  font-size: 11.5px;
  line-height: 1.4;
}

.sketch-drawing-box {
  width: 100%;
  height: 540px;
  border: 1px solid #000;
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sketch-inner-hint {
  font-size: 11px;
  color: #bbb;
  user-select: none;
}

.sketch-signature-table {
  width: 100%;
  border-collapse: collapse;
}

.sketch-signature-table td {
  border: 1px solid #000;
  padding: 0;
  vertical-align: top;
}

.worker-signature-cell {
  width: 50%;
}

.admin-signature-cell {
  width: 50%;
}

.worker-boxes-wrapper {
  display: flex;
  height: 95px;
  border-bottom: 1px solid #000;
}

.signature-box-inner {
  flex: 3;
  border-right: 1px solid #000;
}

.fingerprint-box-inner {
  flex: 1;
}

.admin-box-inner {
  height: 95px;
  border-bottom: 1px solid #000;
}

.cell-label {
  font-size: 11px;
  font-weight: bold;
  text-align: center;
  padding: 4px;
}

.page-footer-note {
  font-size: 9.5px;
  font-style: italic;
  text-align: center;
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
}

@media print {
  .page-sheet {
    page-break-after: always;
    break-after: page;
    border: none;
    box-shadow: none;
    margin: 0;
    padding: 10mm 15mm;
    min-height: 275mm;
  }
}
</style>
